import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { MomentumScreen } from "../components/clients/MomentumScreen";
import type { MomentumSearchParams } from "../components/clients/api";

const searchSchema = z.object({
  signal: z.enum(["rising", "steady", "cooling"]).optional(),
  almost_there: z.boolean().optional(),
  sort: z.enum(["score", "-score", "progress", "-progress", "name", "-name"]).default("-score"),
  page: z.number().int().min(1).default(1),
  page_size: z.number().int().min(1).max(200).default(50),
});

export const Route = createFileRoute("/_auth/clients/momentum")({
  staticData: {
    titleKey: "momentum.title",
    breadcrumbKey: "breadcrumb.operate",
    breadcrumbN: 3,
  },
  validateSearch: searchSchema,
  component: MomentumPage,
});

function MomentumPage() {
  const search = Route.useSearch() as MomentumSearchParams;
  return <MomentumScreen search={search} />;
}
